package com.kinoshazam.uiKit.theme

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.ui.unit.dp

val smallRadius = RoundedCornerShape(2.dp)

val middleRadius = RoundedCornerShape(6.dp)

val largeRadius = RoundedCornerShape(12.dp)